import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ApiService } from '../../service/api_service'
import { Router, ActivatedRoute } from '@angular/router'
import { ExcelService } from '../../exceldownloader';
import * as XLSX from 'xlsx';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { chemistlisttransfermodel } from '../../model';
import * as $ from 'jquery';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs'; 
@Component({
    selector: 'app-chemistmaster',
    template: require('./chemistlisttransfer.component.html'),
    styles: [require('./chemistlisttransfer.component.css')]
})
export class ChemistListTransfer implements OnInit {
    chemistList: any = [];
    headQuarterList: any = [];
    stateList: any = [];
    empData: any = [];
    toEmpData: any = [];
    private columnDefs;
    private rowHeight;
    api: any;
    busy: Subscription;
    columnApi: any;
    defaultColDefine;
    private gridColumnApi;
    value: any
    form_data = new FormData();
    AreaList: any = [];
    RouterList: any = [];
    rowSelectionMultiple: string;
    ChemistId: any = [];
    token:any;
    @ViewChild('close') public modal: ElementRef;
    ChemistListTransferModel: chemistlisttransfermodel = new chemistlisttransfermodel();

    static parameters = [ApiService, Router, ActivatedRoute, NgbModalConfig, NgbModal, ExcelService, HttpClient, ToastrService];
    constructor(private apiService: ApiService, private router: Router, private activatedRoute: ActivatedRoute, config: NgbModalConfig, private modalService: NgbModal, private excelService: ExcelService, private http: HttpClient, private toast: ToastrService) {
        config.backdrop = 'static';
        config.keyboard = false;
        let parent = this;
        this.columnDefs = [
            { headerName: 'S.No.', field: 'sno', valueGetter: "node.rowIndex + 1", width: 90 },
            { headerName: '', field: 'action', width: 150, checkboxSelection: true, headerCheckboxSelection: true, headerCheckboxSelectionFilteredOnly: true },
            // {
            //     headerName: 'Chemist Code', field: "employee_code", filter: 'agTextColumnFilter'
            // },
            { headerName: 'Chemist Name', field: "ChemistName", filter: 'agTextColumnFilter' },
            { headerName: 'Route', field: "RouteName", filter: 'agTextColumnFilter' , width: 300},
            { headerName: 'Area', field: "ChemistArea", filter: 'agTextColumnFilter', width: 300 },
            // { headerName: 'Address', field: "PlanDate", filter: 'agTextColumnFilter' },
        ];
        this.defaultColDefine = { resizable: true };
        this.rowHeight = 50;
    }

    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        this.rowSelectionMultiple = 'multiple';
        this.ChemistListTransferModel.EmployeeCode = '0';
        this.ChemistListTransferModel.EmployeeCodeTo = '0';
        this.ChemistListTransferModel.RouteId = '0';
        this.ChemistListTransferModel.Area_Id = '0';

        this.chemistList = [];
        $('#filter-option').trigger('click');
        this.getEmployee();

    }

    getEmployee() {
        var data = {
            Id: this.token.id
        };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
            this.empData = res.data;
            res.data.filter(data => {
                if (data.EmpActive == '1') {
                    this.toEmpData.push(data);
                }
              })
        })
    }

    getState() {
        this.apiService.getState().subscribe((res: any) => {
            this.stateList = res.data;
        })
    }

    getHeadQuarterList() {
        this.apiService.getHeadQuarterList().subscribe((res: any) => {
            this.headQuarterList = res.data;
        })
    }

    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
        this.api.refreshCells();
    }
    OnEmployeeChange() {
        // console.log(this.ChemistListTransferModel.EmployeeCode);
        this.GetEmployeeAreaList();
        this.GetEmployeeRouteList();
    }

    GetEmployeeAreaList() {
        var data = { "Client_Code": this.ChemistListTransferModel.EmployeeCode };
        this.http.post('/api/usermasters/GetEmployeeAreaAgainstClientCode', data).subscribe((res) => {
            this.AreaList = res;
        })
    }

    GetEmployeeRouteList() {
        var data = { "Client_Code": this.ChemistListTransferModel.EmployeeCode };
        this.http.post('/api/usermasters/GetEmployeeRouteAgainstClientCode', data).subscribe((res) => {
            this.RouterList = res;
        })
    }

    onBtnExport() {
        this.api.exportDataAsCsv({ fileName: 'ChemistList' });
    }

    f_chkString(p_value) {
        var Val = (p_value ? p_value.toString() : "").trim();
        return Val;
    }

    getChemistListTransfer() {
      
        if (this.f_chkString(this.ChemistListTransferModel.EmployeeCode) == '0') {
            this.toast.warning('From Employee  is Required');
            return false;
        }
        if (this.f_chkString(this.ChemistListTransferModel.EmployeeCodeTo) == '0') {
            this.toast.warning('From Employee To is Required');
            return false;
        }
        if (this.f_chkString(this.ChemistListTransferModel.EmployeeCodeTo) != '0' && this.f_chkString(this.ChemistListTransferModel.EmployeeCode) != '0') {

            if (this.ChemistListTransferModel.EmployeeCode == this.ChemistListTransferModel.EmployeeCodeTo) {

                this.toast.warning('From Emp and To Emp can not be same');
                return false;
            }
        }
        
         this.ChemistListTransferModel.id=this.token.id;
        //  this.api.showLoadingOverlay();
        $("#ChemistListTransfer").trigger('click');
           this.busy = this.apiService.listChemisttransfer(this.ChemistListTransferModel).subscribe((res: any) => {
            console.log('response ', res);
            this.chemistList = res.employee;
        });
    }


    emptransfer() {
        this.ChemistId = [];
        this.ChemistId = this.api.getSelectedRows();
        if (this.ChemistId.length == 0) {
            this.toast.warning('Please Select Chemist Details for Transfer');
            return false;
        }
        console.log(this.ChemistId);
        var ChemistTransferId = this.ChemistId.map(item => item._ID).toString();
        let token = JSON.parse(sessionStorage.getItem("currentUser"));
        //  console.log('token', token);
        var data = {
            data: ChemistTransferId, Id: token.id, type: 'transfer', fromEmpCode: this.ChemistListTransferModel.EmployeeCode,
            toEmpcode: this.ChemistListTransferModel.EmployeeCodeTo
        };
        console.log(data);
       this.busy = this.apiService.ChemistListTransferORCopy(data).subscribe((res: any) => {
            if(res.length > 0){
                if(res[0].flag == 1){
                    this.toast.success(res[0].msg);        
                    this.getChemistListTransfer();
                } else {
                    this.toast.warning(res[0].msg); 
                }
            }
        })
    }

    empcopy() {
        this.ChemistId = [];
        this.ChemistId = this.api.getSelectedRows();
        if (this.ChemistId.length == 0) {
            this.toast.warning('Please Select Chemist Details for Copy');
            return false;
        }
        console.log(this.ChemistId);
        var ChemistTransferId = this.ChemistId.map(item => item._ID).toString();
        let token = JSON.parse(sessionStorage.getItem("currentUser"));
        //  console.log('token', token);
        var data = {
            data: ChemistTransferId, Id: token.id, type: 'copy', fromEmpCode: this.ChemistListTransferModel.EmployeeCode,
            toEmpcode: this.ChemistListTransferModel.EmployeeCodeTo
        };
        console.log(data);
        this.busy = this.apiService.ChemistListTransferORCopy(data).subscribe((res: any) => {
            if(res.length > 0){
                if(res[0].flag == 1){
                    this.toast.success(res[0].msg);        
                   
                } else {
                    this.toast.warning(res[0].msg); 
                }
            }

        })
    }





}
